<template>
  <img
    class="object-contain w-full"
    :class="[
      $attrs.class ? $attrs.class : 'h-10'
    ]"
    alt="SenangPay logo"
    src="@/assets/image/logo-senangpay.svg"
  />
</template>